import { render } from "./number.vue?vue&type=template&id=277400ba"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-elements/number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "277400ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('277400ba', __exports__)) {
    console.log('reload')
    api.reload('277400ba', __exports__)
  }
  
  module.hot.accept("./number.vue?vue&type=template&id=277400ba", () => {
    console.log('re-render')
    api.rerender('277400ba', render)
  })

}


export default __exports__